import { EContractState } from "src/shared/types/partner.types";

export const AgreementStatusByValue: Record<EContractState, string> = {
  [EContractState._0]: "Новый",
  [EContractState._1]: "Не заключен",
  [EContractState._2]: "Действующий",
  [EContractState._3]: "На подписании",
  [EContractState._4]: "Закрыт",
  [EContractState._5]: "В процессе закрытия",
  [EContractState._6]: "Приостановлен",
  [EContractState._7]: "",
};
